var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 5.8335L15.8334 8.3335M15.8334 8.3335L18.3334 5.8335M15.8334 8.3335V3.3335M13.3334 17.5002V16.5002C13.3334 15.1 13.3334 14.4 13.0609 13.8652C12.8212 13.3948 12.4388 13.0123 11.9684 12.7726C11.4336 12.5002 10.7335 12.5002 9.33341 12.5002H5.66675C4.26662 12.5002 3.56655 12.5002 3.03177 12.7726C2.56137 13.0123 2.17892 13.3948 1.93923 13.8652C1.66675 14.4 1.66675 15.1 1.66675 16.5002V17.5002M10.4167 6.25016C10.4167 7.86099 9.11091 9.16683 7.50008 9.16683C5.88925 9.16683 4.58341 7.86099 4.58341 6.25016C4.58341 4.63933 5.88925 3.3335 7.50008 3.3335C9.11091 3.3335 10.4167 4.63933 10.4167 6.25016Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpIcon);
export default __webpack_public_path__ + "static/media/ipIcon.e137a2f5d6790d04b683e4008d8f8ba9.svg";
export { ForwardRef as ReactComponent };